<script setup lang="ts">
import { format, parse } from 'date-fns';
import { defineProps, defineEmits } from 'vue';

const props = defineProps<{
  modelValue: string;
}>();

const emit = defineEmits(['update:modelValue']);

const todayFormatted = format(new Date(), 'yyyy-MM-dd');

const parsedModel = props.modelValue
  ? format(parse(props.modelValue, 'dd-MM-yyyy', new Date()), 'yyyy-MM-dd')
  : todayFormatted;

function updateDate(event: Event) {
  const target = event.target as HTMLInputElement;
  const value = format(new Date(target.value), 'dd-MM-yyyy');
  emit('update:modelValue', value);
}
</script>

<template>
  <input
    type="date"
    :value="parsedModel"
    @input="updateDate($event)"
    :min="todayFormatted"
    class="rounded-lg border border-[#333] bg-[#1A1A1A] text-white px-4 py-3 w-full focus:border-[#C59C2F] focus:outline-none transition-all"
  />
</template>

<style scoped>
input {
  transition: all 0.3s ease;
}
</style>
